import { Location, useLocation } from 'react-router-dom'

const initialLocationState = () => ({ pathname: '', search: '', state: {}, hash: '' })

class PathLocationManager {
  private key = 'appLocationHistory'
  private locations: Location[] = []

  constructor(name: string) {
    const jsonFromSessionStorage = sessionStorage.getItem(this.key)
    this.key = name
    this.locations = jsonFromSessionStorage ? JSON.parse(jsonFromSessionStorage) : []
  }

  public getLocations() {
    return this.locations
  }

  public push(location: Location) {
    this.locations.push(location)
    this.dumpToSessionStorage()
  }

  public pop() {
    this.locations.pop()
    this.dumpToSessionStorage()
  }

  public length() {
    return this.locations.length
  }

  public setLocation(index: number, location: Location) {
    this.locations[index] = location
    this.dumpToSessionStorage()
  }

  public getLocation(index: number) {
    return this.locations[index]
  }

  public getPreviousLocation() {
    return this.locations[this.locations.length - 2] || initialLocationState()
  }

  public getPreviousLocationPath() {
    return this.getPreviousLocation().pathname || ''
  }

  public setLocations(locations: Location[]) {
    this.locations = locations
    this.dumpToSessionStorage()
  }

  private dumpToSessionStorage() {
    sessionStorage.setItem(this.key, JSON.stringify(this.locations))
  }
}

export const allLocations = new PathLocationManager('appAllLocationHistory')
export const pastLocations = new PathLocationManager('appPastLocationHistory')
export let isGoBack = false
export const setGoBack = (value: boolean) => (isGoBack = value)

// TODO: Check if need this to be re implemented
export const useUpdateLocations = () => {
  const location = useLocation()

  const updateLocations = (action: string) => {
    switch (action) {
      case 'PUSH':
        allLocations.push(location)
        isGoBack = false
        break
      case 'REPLACE':
        allLocations.push(location)
        isGoBack = false
        break
      case 'POP':
        allLocations.push(location)
        isGoBack = true
        break
      default:
    }
  }

  const updatePastLocations = (action: string) => {
    switch (action) {
      case 'PUSH':
        pastLocations.push(location)
        isGoBack = false
        break
      case 'REPLACE':
        pastLocations.setLocation(pastLocations.length() - 1, location)
        isGoBack = false
        break
      case 'POP':
        pastLocations.pop()
        const appLocation = pastLocations.getLocation(pastLocations.length() - 1)
        if (!(appLocation && appLocation.key === location.key)) {
          pastLocations.setLocations([location])
        }
        isGoBack = true
        break
      default:
    }
  }

  return { updateLocations, updatePastLocations }
}
